import { ContainerList } from '@/components/Containers/ContainerList';
import { Container } from '@/components/Containers/Container';
import { Skeleton } from '@frontend/ui/components/skeleton';

export const CampaignSkeleton = () => {
	return (
		<>
			<ContainerList>
				{Array.from({ length: 8 }).map(() => (
					<Skeleton className="h-60" />
				))}
			</ContainerList>
			<Container>
				<Skeleton className="h-96" />
			</Container>
			<Container className="grid grid-cols-2">
				<Skeleton className="h-96" />
			</Container>
		</>
	);
};
